import { Icon } from '@blend-ed/blendx-ui';
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import WelcomeScreen from './WelcomeScreen';
import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import intlMessages from '../../messages';
import ChatInput from './ChatInput';
import LoadingIndicator from './LoadingIndicator';
import MessageGroup from './MessageGroup';

function AiTutor({ messages, inputText, setInputText, handleSendMessage, intl, isLoading, conversationStartersQuestions, conversationStartersTopics }) {
  const chatEndRef = useRef(null);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <div className="learning-view__ai-tutor">
      <div className="ai-tutor__header">
        <Icon icon="robot" type="line" size="md" variant="primary" withBackground className="rounded" />
        <div className="ai-tutor__info learning-view__title">
          <div className="learning-view__title-text">{intl.formatMessage(intlMessages.aiTutor)}</div>
          <div className="learning-view__unit">{intl.formatMessage(intlMessages.alwaysHereToHelp)}</div>
        </div>
      </div>
      <div className="ai-tutor__content">
        {messages.length === 0 ? (
          <WelcomeScreen
            suggestedQuestions={conversationStartersQuestions}
            suggestedTopics={conversationStartersTopics}
            intl={intl}
            handleSendMessage={handleSendMessage}
            isLoading={isLoading}
          />
        ) : (
          <div className="message-list">
            {messages.map(message => (
              <MessageGroup
                key={message.id}
                message={message}
                intl={intl}
              />
            ))}
            {isLoading && <LoadingIndicator />}
            <div ref={chatEndRef} />
          </div>
        )}
      </div>
      <ChatInput
        value={inputText}
        onChange={setInputText}
        onSend={handleSendMessage}
        placeholder={intlMessages.askAnything}
      />
    </div>
  );
}

AiTutor.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    contentType: PropTypes.string,
    createdAt: PropTypes.string.isRequired,
  })).isRequired,
  inputText: PropTypes.string.isRequired,
  handleSendMessage: PropTypes.func.isRequired,
  conversationStartersQuestions: PropTypes.array.isRequired,
  conversationStartersTopics: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(AiTutor); 